import { Component, Input, Output, EventEmitter, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { MegaMenuConfig } from '../../models/mega-menu.model';
import { SessionService } from '../../services/session.service';

@Component({
  selector: 'app-mobile-menu',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './mobile-menu.component.html',
  styleUrl: './mobile-menu.component.scss',
})
export class MobileMenuComponent {
  private readonly sessionService = inject(SessionService);
  readonly usuario = this.sessionService.usuario;

  @Input() isOpen = false;
  @Input() mobileSubmenu: 'store' | 'plantel' | null = null;
  @Input() storeMenuConfig!: MegaMenuConfig;
  @Input() plantelMenuConfig!: MegaMenuConfig;

  @Output() closeMenu = new EventEmitter<void>();
  @Output() toggleSubmenu = new EventEmitter<'store' | 'plantel'>();

  onClose(): void {
    this.closeMenu.emit();
  }

  onToggleSubmenu(submenu: 'store' | 'plantel'): void {
    this.toggleSubmenu.emit(submenu);
  }

  signOut(): void {
    this.sessionService.cerrarSesion();
    this.onClose();
  }
}
